import { AssayEvaluationResultCustomData } from '@/modules/diagnosisModule/components/assays-evaluations-grid/assays-evaluations-grid.models'
import { Nullable } from '@/shared/types/app.types'

export interface AssaysEvaluationsGridSidePanelState {
    id: Nullable<number>
    comment: Nullable<string>
    originalComment: Nullable<string>
    customData: Nullable<AssayEvaluationResultCustomData[]>
    isCommentBoxOpen: boolean
}
export const initialAssaysEvaluationsGridSidePanelState =
    (): AssaysEvaluationsGridSidePanelState => ({
        id: null,
        originalComment: null,
        comment: null,
        customData: null,
        isCommentBoxOpen: false
    })
